import { render } from "./CardPreviewWPP.vue?vue&type=template&id=b050917a"
import script from "./CardPreviewWPP.vue?vue&type=script&lang=js"
export * from "./CardPreviewWPP.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__